import React from 'react';
import { FormattedMessage } from 'react-intl';

import withTextContext from '../../hoc/withTextContext';

function HeaderText({ paymentStatusText, paymentId }: { paymentId: string } & Partial<ITextContext>) {
  return paymentStatusText ? (
    <div className="header__text">
      <FormattedMessage id={paymentStatusText} values={{ paymentId }} />
    </div>
  ) : (
    <div className="header__text" />
  );
}
export default withTextContext(HeaderText);
